<template>
  <div>
    <list-table
      :url="url"
      title="شارژ موجود"
      :fields="fields"
      :params="params"
      :btns="btns"
    ></list-table>
    <b-modal
      id="chargeRefund"
      ok-title="ذخیره"
      cancel-title="انصراف"
      @ok="saveCharge"
    >
      <b-form-group label="کد رهگیری:">
        <b-form-input v-model="chargeObj.tracking_number"></b-form-input>
      </b-form-group>
      <b-form-group label="مبلغ شارژ:">
        <b-form-input v-model="chargeObj.amount"></b-form-input>
      </b-form-group>
    </b-modal>
  </div>
</template>
  <script>
/**
 * TableShowData component is used to display data in a tabular format.
 */
import TableShowData from "../../components/table";

/**
 * persianDate is a helper function used to format date in persian format
 * Uncomment the import statement if it is being used in the component.
 */
// import persianDate from '../../helpers/persianDate';

/**
 * SET_BREADCRUMB is a Vuex action used to set the breadcrumb.
 */
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";

export default {
  name: "chargeAvailableList",
  /**
   * Data object containing the properties used by the component.
   *
   * @property {string} url - The API endpoint for fetching data.
   * @property {Array} fields - The fields to be displayed in the table.
   * @property {Array} params - The parameters to be used in the API call.
   */
  data() {
    return {
      url: "~transaction/refunds/admin/summery",
      chargeObj: {
        user_id: null,
        amount: 0,
        tracking_number: "",
      },
      fields: [
        {
          key: "user_id",
          label: "کد کاربر",
        },
        {
          key: "user.name",
          label: "نام کاربر",
        },
        {
          key: "user.mobile",
          label: "شماره تماس",
        },
        {
          key: "amount",
          label: "موجودی (ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
          tdClass: "ltr",
        },
        {
          key: "btns",
          label: "عملیات",
        },
      ],
      params: [],
      btns: [
        {
          icon: "card-checklist",
          title: "شارژ",
          handler: (e) => {
            (this.chargeObj.user_id = e.user_id),
              this.$bvModal.show("chargeRefund");
          },
        },
      ],
    };
  },
  components: {
    "list-table": TableShowData,
  },
  /**
   * Lifecycle hook called when the component is mounted.
   * Dispatch the SET_BREADCRUMB action to set the breadcrumb.
   */
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "شارژ موجود ریفاند" }]);
  },
  methods: {
    saveCharge(e) {
      e.preventDefault();
      httpHelper
        .postData("~transaction/refunds/admin/charge", this.chargeObj)
        .then((responce) => {
          this.url = "~transaction/refunds/admin/summery?t=" + new Date().getTime();
          this.$bvModal.hide("chargeRefund");
        });
    },
  },
};
</script>
  <style>
.ltr {
  direction: ltr;
}
</style>